module.exports = __webpack_public_path__ + "img/p113.b14a4ccd.png";